
import NickNameModal from './components/NicknameModal';

export default {
  'nickNames/components/NickNameModal': NickNameModal,
};
